import React, { useState, useEffect } from "react";
import './AboutNewRead1.css';
import axios from "axios";
function AboutNewRead() {

  const [About, setAbout] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const response = await axios.get(
        "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/get_about_us_list"
      );
      setAbout(response.data.data);
    };

    fetchData();
  }, []);

  return (
    <>
      <section className="about-page">
        {About.filter((Data) => Data.about_id === "4").map(
          (Data, index) => {
            return (
              <div className="container">
                <div className="row" key={index}>
                  <div className="col-lg-6 col-md-12 col-sm-12 col-12 order-lg-1 order-2">
                    <div className="about_wrapper">
                      <figure className="mb-0 about-image1">
                        <img src={`https://cyberathon.com/NLF/${Data.img_1}`} alt="" />
                      </figure>
                      <figure className="mb-0 about-image2">
                        <img
                          src={`https://cyberathon.com/NLF/${Data.img_2}`}
                          alt=""
                          className="img-fluid"
                        />
                      </figure>

                      <figure className="mb-0 about-dot">
                        <img
                          src="about-img/about-us-dot.png"
                          alt=""
                          className="img-fluid"
                        />
                      </figure>
                      <figure className="mb-0 about-leftcircle">
                        <img
                          src="about-img/about-us-leftcircle.png"
                          alt=""
                          className="img-fluid"
                        />
                      </figure>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 col-sm-12 col-12 order-lg-2 order-1">
                    <div className="about_content aos-init" data-aos="fade-right">
                      <h3>{Data.abt_title}</h3>

                      <h2 className="text-white">
                        {" "}
                        {Data.abt_sub_title}
                      </h2>
                      <p className="text1" dangerouslySetInnerHTML={{ __html: Data.abt_description }}>
                      </p>

                      {/* <p className="text1">
                  
At NLF Solutions, we believe that the most significant thing we build isn't just Architectural Products, but trust. We take pride in providing the right product at the right price, backed by reliability and exceptional service. Our focus extends beyond mere Architectural Products; it encompasses a holistic lifestyle approach. We emphasize both function and aesthetics throughout the design process, from concept to final installation.

                 
                </p> */}

                      {/* <p className="text2">
                  It Is Our Goal And Driving Ambition To Be The Trusted Partner
                  Of Choice. Our success is driven by a team of experienced, professional and creative designers, supported by sincere and hardworking skilled personnel, all committed to delivering prompt and exceptional services to fulfil the need of the projects.

                </p> */}
                    </div>
                  </div>
                </div>
              </div>
            );
          }
        )}

        {/* <figure className="mb-0 about-rightcircle">
          <img
            src="about-img/about-us-rightcircle.png"
            alt=""
            className="img-fluid"
          />
        </figure> */}
      </section>
    </>
  );
}

export default AboutNewRead;
